import { Outlet } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AppHeader } from "@/components/layout/AppHeader";
import { AppSidebar } from "@/components/layout/AppSidebar";
import { SidebarPeekProvider } from "@/components/layout/SidebarPeek";

export function AppLayout() {
  return (
    <SidebarProvider defaultOpen>
      <SidebarPeekProvider>
        <TooltipProvider delay={0}>
          <AppSidebar />
          <SidebarInset className="app-shell flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden shadow-none">
            <a
              href="#main-content"
              className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:z-50 focus:rounded-xl focus:border focus:border-line focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground focus:inset-inline-start-4"
            >
              Skip to main content
            </a>
            <div className="content-inset flex min-h-0 flex-1 flex-col overflow-hidden">
              <AppHeader />
              <div
                id="main-content"
                tabIndex={-1}
                className="mt-(--section-gap) flex min-h-0 flex-1 flex-col overflow-hidden outline-none"
              >
                <Outlet />
              </div>
            </div>
          </SidebarInset>
        </TooltipProvider>
      </SidebarPeekProvider>
    </SidebarProvider>
  );
}
